import {Badge} from "@mantine/core";
import {I18n} from "@aws-amplify/core";

// One colour for every entity type: the type is told apart by its text, and colour
// would carry nothing the label does not (§13).
export const EntityTypeBadge = ({entityType}: { entityType?: string | null }) => (
    <Badge color='gray' variant='light'>
        {entityType ? I18n.get(entityType) : '—'}
    </Badge>
);
